import type { UiStrings } from '@/constants/ui-locale'
import type { SharedRoomHeaderVariant } from '@/hooks/useSharedRoomUi'
import type { SharedRoomMember } from '@/pages/Meetings/utils/sharedRoomPresentation'
// import SharedRoomSimilarChip from './SharedRoomSimilarChip'

/** Left-column chip only; in-room controls live in {@link SharedRoomInRoomControls}. */
export default function SharedRoomHeaderStrip({
  variant,
  t: _t,
  onJoin: _onJoin,
}: {
  variant: SharedRoomHeaderVariant
  roomTitle: string | null
  members: SharedRoomMember[]
  canLeave: boolean
  leaving: boolean
  t: UiStrings
  locale: string
  onJoin: () => void
  onLeave: () => void
}) {
  if (variant !== 'similarDetected') return null
  // TODO: Re-enable "Similar meeting detected · Join" chip when rejoin-from-dismiss is implemented.
  // return <SharedRoomSimilarChip t={t} onJoin={_onJoin} />
  return null
}
